import { render, staticRenderFns } from "./CourseGroupShow.vue?vue&type=template&id=9a4f3696"
import script from "./CourseGroupShow.vue?vue&type=script&lang=ts"
export * from "./CourseGroupShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports